export const COLUMNS = [
    {
      Header: 'Id',
      Footer: 'Id',
      accessor: 'id',
      disableFilters: true,
      sticky: 'left'
    },
    {
      Header: 'Feature Name',
      Footer: 'Feature Name',
      accessor: 'featureName',
      sticky: 'left'
    },
    {
      Header: 'Feature Description',
      Footer: 'Feature Description',
      accessor: 'featureDesc',
      sticky: 'left'
    }
    // {
    //   Header: 'Action',
    //   Footer: 'Action',
    //   // accessor: 'action'
    // }
  ]